//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoPagamentoResource from '../../common/resources/configuracao/configuracao-pagamento';

export default {
  name: 'ConfiguracaoPagamento',
  data() {
    return {
      configuracaoPagamentoResource: configuracaoPagamentoResource(this.$resource),
      configuracoes: [],
      moduloPagamento: {},
      sapVisible: true,
    };
  },
  components: {},
  methods: {
    requestPopular() {
      this.configuracaoPagamentoResource.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.configuracoes = objeto.map((el) => {
            el.valorParametro = el.valorParametro === 'true';
            if (el.chaveParametro === 'SAP_AUTOMATICO') {
              this.moduloPagamento = el;
            }
            return el;
          });
        });
    },
    requestValidarVisibilidadeSap() {
      this.configuracaoPagamentoResource.pesquisarSap()
        .then((response) => {
          this.sapVisible = response.data;
        });
    },
    requestAtualizar(objeto) {
      const payload = Object.assign({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoPagamentoResource.atualizar(payload)
      .then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
  },
  mounted() {
    this.requestPopular();
    this.requestValidarVisibilidadeSap();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoPagamento.vue?vue&type=script&lang=js&